import React from 'react';
import './MarketKnowledge.css';
import PICS from '../assets/images';

const MarketKnowledge = () => {
  return (
    <section className="market-knowledge-section" id="market-knowledge-section">
      <div className="market-knowledge-container">
        <span className="team-label">The "Glocal" Advantage</span>
        <h2 className="section-title">
          Meet the <span className="highlight">Team</span>
        </h2>
        <p className="section-description">
          Our team is the living embodiment of the "emic" approach. We bring together UK strategic discipline with unparalleled local expertise, providing a truly "glocal" perspective that no other agency can offer.
        </p>
        <div className="market-cards">
          <div className="market-card">
            <div className="card-image-wrapper">
              {/* <span className="card-label">The Strategist</span> */}
              <img src={PICS.shabazzPic} alt="The Strategist" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Shabazz</h3>
              <p className="specialties-title">The Strategist</p>
              <p className="specialties-title">Key Specialties:</p>
              <p className="specialties-text">With a UK background in brand strategy, he brings a global perspective and a meticulous, results-driven approach.</p>
            </div>
          </div>
          <div className="market-card">
            <div className="card-image-wrapper">
              {/* <span className="card-label">The Insider</span> */}
              <img src={PICS.kyunaPic} alt="The Insider" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Kyuna</h3>
              <p className="specialties-title">The Insider</p>
              <p className="specialties-title">Key Specialties:</p>
              <p className="specialties-text">Born and raised in Korea, she is our cultural compass, providing the on-the-ground knowledge and local fluency essential for true market connection.</p>
            </div>
          </div>
          <div className="market-card">
            <div className="card-image-wrapper">
              {/* <span className="card-label">The Operator</span> */}
              <img src={PICS.chrisPic} alt="The Operator" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Christopher</h3>
              <p className="specialties-title">Technical Specialist</p>
              <p className="specialties-title">Key Specialties:</p>
              <p className="specialties-text">As a project management expert from the UK, he ensures that your market entry is executed flawlessly, bridging the logistical divide.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketKnowledge;